import { loadHome } from '../rest-services/home-rest-service';
import { transformHome } from '../filters/homeFilters/home-filters';
import { getTopPerformers } from './seller-service';

export const getHome = async (params, orgId) => {
  const home = await loadHome(params);
  const topPerformers = await getTopPerformers(orgId);
  return transformHome(home.data, topPerformers);
};
